import type { InputProps } from '@monoimin/forms/gravity-form/types';

export const DateInput = ({
  label,
  adminLabel,
  isRequired,
  customId,
  description,
  layoutGridColumnSpan = 12,
  max,
  min,
}: InputProps) => {
  const gridColumn = `span ${layoutGridColumnSpan} / span ${layoutGridColumnSpan}`;

  return (
    <div
      style={{
        gridColumn,
      }}
      className='relative'
    >
      <div className='flex flex-col mb-2'>
        <label className='text-xl' htmlFor={customId}>
          {label}
        </label>
        {description && <span className=''>{description}</span>}
      </div>

      <div className='w-full group h-15 md:h-16 flex'>
        <input
          id={customId}
          type={'date'}
          name={adminLabel || customId}
          required={isRequired}
          autoComplete={'on'}
          max={max}
          min={min}
          data-testid='date-input'
          className={
            // без flex у родителя и flex-1 у самого инпута он сжимается на сафари
            'peer w-full flex-1 h-full py-3.5 px-3.5 focus:outline-0 text-xl bg-white border border-darkGrey'
          }
        />
      </div>
    </div>
  );
};
